import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=65ba2030&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports